import { cn } from '@change/ds-utils';

import { AmountButton } from 'src/app/shared/components/payments';

import { useSunriseHoldoutExperiment } from '../../sunriseHoldoutExperiment/hooks/useSunriseHoldoutExperiment';

import { AmountInput } from './components/AmountInput';
import { useAmountSelector } from './hooks/useAmountSelector';

export function AmountSelector({ acceptMembership }: { acceptMembership: boolean }): JSX.Element {
	const {
		data: {
			amount,
			currency,
			currencySymbol,
			currencySymbolPosition,
			decimalSeparator,
			errorMessage,
			isSelected,
			isCustomAmount,
			showFractionNumber,
			value,
			placeholder,
			...useAmountSelectorData
		},
		actions: { onChange, onClick, onFocus },
	} = useAmountSelector();

	const { isSunriseEnabled, ...sunriseHoldoutExperiment } = useSunriseHoldoutExperiment({
		isSunriseEnabled: useAmountSelectorData.isSunriseEnabled,
	});

	return (
		<div className="flex w-full justify-center gap-2 pb-1 pt-3">
			<div
				className={cn({
					'basis-1/5': sunriseHoldoutExperiment.shouldUseBlueCards,
					'basis-1/4': !sunriseHoldoutExperiment.shouldUseBlueCards,
				})}
			>
				<AmountButton
					dataQaAttribute="default-amount-button"
					amount={amount}
					currency={currency}
					isSelected={acceptMembership && isSelected}
					onClick={onClick}
					isSunriseEnabled={isSunriseEnabled}
					height="40px"
				/>
			</div>
			<div
				className={cn({
					'basis-4/5': sunriseHoldoutExperiment.shouldUseBlueCards,
					'basis-3/4': !sunriseHoldoutExperiment.shouldUseBlueCards,
				})}
			>
				<AmountInput
					currencySymbol={currencySymbol}
					errorMessage={errorMessage}
					isSelected={acceptMembership && isCustomAmount}
					onChange={onChange}
					onFocus={onFocus}
					value={value}
					placeholder={placeholder}
				/>
			</div>
		</div>
	);
}
